import React from 'react';
import { motion } from 'framer-motion';
export function SystemPitch() {
  return <section className="py-20 px-4 max-w-4xl mx-auto text-center pt-[40px] pb-[40px]" data-id="element-214">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-215">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-brown font-bold leading-tight mb-8" data-id="element-216">
          Un sistema completo, no un libro más.
        </h2>

        <p className="font-sans font-bold text-gold uppercase tracking-widest text-sm mb-8" data-id="element-217">
          El sistema de amor propio más completo de eBookPlanet.
        </p>

        <div className="space-y-6 font-sans text-lg text-brown/80 leading-relaxed max-w-3xl mx-auto mb-12 text-left md:text-center" data-id="element-218">
          <p data-id="element-219">
            <strong data-id="element-220">Hackeá tu Realidad</strong> reúne todo lo que necesitás para
            dejar de ser tu peor enemigo: las frases que instalan tu nueva forma
            de pensar, el protocolo que las convierte en hábito y las
            herramientas para desarmar lo que te sabotea.
          </p>
          <p data-id="element-221">
            Los más exitosos —millonarios, atletas de élite, gente que parece
            tener algo que el resto no— en el fondo comparten una sola cosa:
            aprendieron a hablarse distinto. No nacieron con eso, lo entrenaron.
            Y hoy lo tenés a un clic de distancia por un precio irrisorio.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-222">
          {[{
          value: '3',
          label: 'Tomos'
        }, {
          value: '6',
          label: 'Bonos'
        }, {
          value: '100',
          label: 'Frases'
        }, {
          value: '21',
          label: 'Días de plan'
        }].map((stat, i) => <div key={i} className="bg-white px-6 py-4 rounded-2xl shadow-sm border border-gold/20 min-w-[120px]" data-id="element-223">
              <div className="font-serif text-3xl font-bold text-gold mb-1" data-id="element-224">
                {stat.value}
              </div>
              <div className="font-sans text-xs font-bold text-brown/60 uppercase tracking-wider" data-id="element-225">
                {stat.label}
              </div>
            </div>)}
        </div>
      </motion.div>
    </section>;
}